import React from 'react';
import { GalleryMenu } from '.';
import { getGalleryMenuProps } from '../../../../../utils/contentful/getGalleryMenuProps';
import { GalleryLinkList } from './GalleryLinkList';
export const ContentfulGalleryMenu = ({ activeItem, }) => {
    const { column1Props, column2Props } = getGalleryMenuProps(activeItem);
    return (React.createElement(GalleryMenu, { column1: React.createElement(GalleryLinkList, Object.assign({}, column1Props, { size: "large" })), column2: React.createElement(GalleryLinkList, Object.assign({}, column2Props)) }));
};
//# sourceMappingURL=ContentfulGalleryMenu.js.map